
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import './index.css'
import AuthProvider from './providers/AuthProvider'
import TooltipAndToastProvider from './providers/TooltipAndToastProvider'
import QueryProvider from './providers/QueryProvider'
import * as Sentry from '@sentry/react'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
      <AuthProvider>
        <TooltipAndToastProvider>
          <QueryProvider>
            <RouterProvider router={router} />
          </QueryProvider>
        </TooltipAndToastProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
